module.exports = __webpack_public_path__ + "img/ring_g_i_null_0.d8e9c676.png";